import { StyleSheet, css } from 'aphrodite'
import PropTypes from 'prop-types'
import plusIcon from '../../assets/plus-icon.png'

const IconCirclePlus = ({ dynamicStyle }) => {
  return <img src={plusIcon} className={css(styles.img, dynamicStyle)} />
}

const styles = StyleSheet.create({
  img: {
    width: '20px',
  },
})

IconCirclePlus.propTypes = {
  dynamicStyle: PropTypes.object,
}

export default IconCirclePlus
